import {
    drillThruAllowed,
    getCustomColorSeriesForGroupChart,
    getPieLegendTitle,
    valueFormatter,
} from '../Charts/chartHelperFunctions'
import { SPACING_TOP } from './chartOptions'

export const getPieOptions = function (
    vuId: number,
    vuChartDetails: { [s: string]: any },
    vuChartVariationType: string,
    vuChartSettings: { [s: string]: any },
    vuChartData: {
        [s: string]: any
    },
    enable3dview: boolean,
    showLegend: boolean,
    vuChartWidth: number,
    userTypeId:string,
    drillThruChartPoint: {
        (seriesName: string, categoryName: string, pointValue: any): void
        (arg0: string, arg1: any, arg2: any): void
    }
) {
    const dataPoints0: { [s: string]: any }[] = []
    const dataPoints1: { [s: string]: any }[] = []
    const dataPoints2: { [s: string]: any }[] = []
    switch (vuChartVariationType) {
        case 'C_1M_1X_or_1Y':
        case 'C_1M_1X_and_1Y':
        default:
            vuChartData.dataSeries.forEach(function (
                dataSeries: { data: any[]; name: any; measuretype: any },
                index_i: number
            ) {
                dataSeries.data.forEach(function (dataPoint, index_k) {
                    const pieSeries: { [s: string]: any } = {
                        name: dataSeries.name,
                        measuretype: dataSeries.measuretype,
                        dataLabels: { enabled: vuChartSettings.ShowChartDataLabel, inside: true },
                        y: parseFloat(dataPoint),
                    }

                    const sliceColor = getCustomColorSeriesForGroupChart(
                        getPieLegendTitle(vuChartData),
                        dataSeries.name
                    )
                    if (sliceColor !== '') {
                        pieSeries.color = sliceColor
                        pieSeries.className = 'labelDefinedColor'
                    }

                    if (index_k == 0) {
                        dataPoints0.push(pieSeries)
                    } else if (index_k == 1) {
                        dataPoints1.push(pieSeries)
                    } else if (index_k == 2) {
                        dataPoints2.push(pieSeries)
                    }
                })
            })
            break
        case 'C_NM_1D':
        case 'C_2M_1X_or_1Y':
        case 'C_3M_1X_or_1Y':
            vuChartData.dataSeries.forEach(function (
                dataSeries: { data: any[]; measuretype: any },
                index_i: number
            ) {
                dataSeries.data.forEach(function (dataPoint, index_k) {
                    const categoryName = vuChartData.xAxis.category[index_k]
                    const pieSeries: { [s: string]: any } = {
                        name: categoryName,
                        measuretype: dataSeries.measuretype,

                        y: parseFloat(dataPoint),
                        dataLabels: {
                            enabled: vuChartSettings.ShowChartDataLabel,
                            inside: true,
                        },
                    }

                    const sliceColor = getCustomColorSeriesForGroupChart(
                        getPieLegendTitle(vuChartData),
                        categoryName
                    )
                    if (sliceColor != '') {
                        pieSeries.color = sliceColor
                        pieSeries.className = 'labelDefinedColor'
                    }
                    if (index_i == 0) {
                        dataPoints0.push(pieSeries)
                    } else if (index_i == 1) {
                        dataPoints1.push(pieSeries)
                    } else if (index_i == 2) {
                        dataPoints2.push(pieSeries)
                    }
                })
            })
            break
    }
    let twoPies = false
    let threePies = false
    let multiplePies = false

    if (
        (dataPoints1.length > 0 && dataPoints2.length == 0) ||
        (dataPoints1.length == 0 && dataPoints2.length > 0)
    ) {
        twoPies = true
    } else if (dataPoints1.length > 0 && dataPoints2.length > 0) {
        threePies = true
    }
    if (twoPies || threePies) {
        multiplePies = true
    }

    const series0: { [s: string]: any } = {}
    const series1: { [s: string]: any } = {}
    const series2: { [s: string]: any } = {}

    if (multiplePies) {
        if (twoPies) {
            // series0
            series0.type = 'pie'
            series0.name = getPieSeriesName(vuChartData, vuChartVariationType, 0)
            series0.center = [vuChartWidth / 3, 140]
            series0.showInLegend = true
            series0.data = dataPoints0

            // series1
            series1.type = 'pie'
            series1.name = getPieSeriesName(vuChartData, vuChartVariationType, 1)
            series1.center = [(2 * vuChartWidth) / 3, 140]
            series1.showInLegend = false
            series1.linkedTo = ':previous'
            series1.data = dataPoints1
        } else if (threePies) {
            // series0
            series0.type = 'pie'
            series0.name = getPieSeriesName(vuChartData, vuChartVariationType, 0)
            series0.center = [vuChartWidth / 4, 250]
            series0.showInLegend = true
            series0.data = dataPoints0
            // series1
            series1.type = 'pie'
            series1.name = getPieSeriesName(vuChartData, vuChartVariationType, 1)
            series1.center = [vuChartWidth / 2, 80]
            series1.showInLegend = false
            series1.linkedTo = ':previous'
            series1.data = dataPoints1

            // series2
            series2.type = 'pie'
            series2.name = getPieSeriesName(vuChartData, vuChartVariationType, 2)
            series2.center = [(3 * vuChartWidth) / 4, 250]
            series2.showInLegend = false
            series2.linkedTo = ':previous'
            series2.data = dataPoints2
        }
    } else {
        series0.type = 'pie'
        series0.name = vuChartData.xAxis.category[0]
        series0.showInLegend = true
        series0.data = dataPoints0
    }
    let labelItems = []
    let name1 = getPieSeriesName(vuChartData, vuChartVariationType, 0)
    labelItems.push(name1)
    if (dataPoints1.length > 0) {
        let name2 = getPieSeriesName(vuChartData, vuChartVariationType, 1)
        labelItems.push(name2)
    }
    if (dataPoints2.length > 0) {
        let name3 = getPieSeriesName(vuChartData, vuChartVariationType, 2)
        labelItems.push(name3)
    }

    const measureDataType = vuChartDetails.MeasureList[0].MetaData.DataType.toString()
    const chartOptions: { [s: string]: any } = {
        credits: {
            enabled: false,
        },
        title: {
            text: '',
            margin: 25,
            style: {
                fontFamily: 'Helvetica',
                fontSize: '14px',
            },
        },
        exporting: {
            enabled: true,
            type: 'image/png',
            filename: 'healthlevel_chart',
            buttons: {
                printButton: {
                    enabled: false,
                },
                exportButton: {
                    enabled: false,
                },
            },
        },
        navigation: {
            buttonOptions: {
                enabled: false,
            },
        },
        chart: {
            type: 'pie',
            spacingTop: SPACING_TOP,
            animation: vuChartSettings.ShowChartAnimation,
            options3d: {
                enabled: enable3dview,
                alpha: 45,
                beta: 0,
            },
            backgroundColor: '#FFFFFF',
            className: 'highcharts-pie-chart',
            events: {
                render: function () {
                    const chart: any = this,
                        left = vuChartWidth / 2 + (chart.series.length > 1 ? 20 : -70),
                        top = 35
                    if (this.customText == undefined) {
                        this.customText = chart.renderer
                            .text(vuChartData.yAxis.title, left, top, true)
                            .attr({
                                align: 'center',
                                'font-weight': 'bold',
                                'font-size': '14px',
                                'font-family': 'Helvetica',
                            })
                            .addClass('customHighChartsTitle')
                            .add()
                    }
                    if (this.customText !== undefined) {
                        this.customText.attr({
                            x: left,
                            y: top,
                        })
                    }
                    const series1 = this.series[0]
                    const series2 = this.series[1]
                },
            } as { [s: string]: any },
        },
        xAxis: {
            visible: false,
        },
        yAxis: {
            visible: false,
        },
        plotOptions: {
            pie: {
                depth: 10,
                size: twoPies ? 200 : threePies ? 125 : 275,
                ignoreHiddenPoint: true,
                dataLabels: {
                    enabled: vuChartSettings.ShowChartDataLabel,
                    distance: 10,
                    color: 'black',
                    formatter: function () {
                        let labelVal = ''

                        let labeltext = ''
                        if (vuChartSettings.ShowChartZeroValue == false) {
                            if (this.y > 0) {
                                labeltext = valueFormatter(this.y, measureDataType)
                            }
                        } else {
                            labeltext = valueFormatter(this.y, measureDataType)
                        }

                        if (labeltext != '') {
                            labelVal = this.point.name + ': ' + labeltext //healthLevelCharts.valueFormatter(this.y, measureDataType);

                            let percStr = ''
                            if (this.percentage != undefined) {
                                percStr = ' (' + Math.round(this.percentage) + '%)'
                            }
                            return labelVal + percStr
                        }
                    },
                } as { [s: string]: any },
                showInLegend: true,
            } as { [s: string]: any },
            series: {
                cursor: drillThruAllowed(
                    0,
                    vuChartDetails.AllowDrillThru,
                    vuChartDetails.MeasureList,
                    userTypeId
                )
                    ? 'pointer'
                    : 'default',
                animation: vuChartSettings.ShowChartAnimation,
                point: {
                    events: {
                        click: function (event: { point: { [s: string]: any } }) {
                            if (
                                !drillThruAllowed(
                                    event.point.series.index,
                                    vuChartDetails.AllowDrillThru,
                                    vuChartDetails.MeasureList,
                                    userTypeId
                                )
                            )
                                return
                            //let pointValue = event.point.y;
                            const pointValue = valueFormatter(event.point.y, measureDataType)

                            switch (vuChartVariationType) {
                                case 'C_1M_1X_or_1Y':
                                    drillThruChartPoint('', event.point.name, pointValue)
                                    break
                                default:
                                    drillThruChartPoint(
                                        event.point.series
                                            .name /*works b/c of way that the data is structured, need to make more consistent in future*/,
                                        event.point.name,
                                        pointValue
                                    )
                                    break
                            }
                        },
                    },
                },
            },
        },
        tooltip: {
            formatter: function () {
                let labelVal = ''

                if (vuChartData.yAxis.title != '') {
                    labelVal =
                        getPieLegendTitle(vuChartData) +
                        ': <strong>' +
                        this.point.name +
                        '</strong><br/>'
                    labelVal += vuChartData.yAxis.title
                } else {
                    labelVal =
                        getPieLegendTitle(vuChartData) +
                        ': <strong>' +
                        this.point.series.name +
                        '</strong><br/>'
                    labelVal += this.point.name
                }

                labelVal += ': <strong>' + labelVal + '</strong>'

                let percStr = ''
                if (this.percentage != undefined) {
                    percStr = ' (' + Math.round(this.percentage) + '%)'
                }
                return labelVal + percStr
            },
        } as { [s: string]: any },
        legend: {
            enabled: showLegend,
            floating: false,
            draggable: false,
            title: {
                text: '', // healthLevelCharts.getPieLegendTitle(vuChart, vuChartData)
            },
            shadow: false,
            borderWidth: 0,
            borderRadius: 2,
            layout: 'vertical',
            align: 'right',
            y: 25,
            itemWidth: 125,
            verticalAlign: 'top',
            backgroundColor: '#FFFFFF',
            events: {
                itemClick: (event: any) => {
                    const item = event.legendItem
                    event.legendItem.series.chart?.series[0].points[item.index].update({
                        visible: !item.visible,
                    })
                    if (event.legendItem.series.chart?.series.length > 1) {
                        event.legendItem.series.chart?.series[1].points[item.index].update({
                            visible: !item.visible,
                        })
                    }
                    if (event.legendItem.series.chart?.series.length > 2) {
                        event.legendItem.series.chart?.series[2].points[item.index].update({
                            visible: !item.visible,
                        })
                    }
                    return false
                },
            },
        },
        series:
            dataPoints2.length > 0 && dataPoints1.length > 0
                ? [series0, series1, series2]
                : dataPoints1.length > 0
                  ? [series1, series0]
                  : [series0],
    }

    // TODO !! tie legend to both series
    // To enable legend operations on first series to propogate on other series.
    // $(vuChart.series[0].data).each(function (i, e) {
    //     if (e.legendItem && e.legendItem.group){
    //         e.legendItem.group.on('click', function (event) {
    //             let legendItem = e.name;
    //             event.stopPropagation();

    //             $(vuChart.series).each(function (j, f) {
    //                 $(this.data).each(function (k, z) {
    //                     if (z.name == legendItem) {
    //                         if (z.visible) {
    //                             z.setVisible(false, false);
    //                         }
    //                         else {
    //                             z.setVisible(true, false);
    //                         }
    //                     }
    //                     // NOTE: The pie charts do not reflow properly and the title become misaligned
    //                     // if you use redraw on them
    //                     vuChart.redraw()
    //                 });
    //             });
    //         });
    //         e.legendItem.group.on('mouseover', function (event) {
    //             let legendItem = e.name;
    //             event.stopPropagation();

    //             $(vuChart.series).each(function (j, f) {
    //                 $(this.data).each(function (k, z) {
    //                     if (z.name == legendItem) {
    //                     z.setState('hover');
    //                     } else {
    //                         z.setState('inactive');
    //                     }
    //                 });
    //             });
    //         });
    //         e.legendItem.group.on('mouseout', function (event) {
    //             let legendItem = e.name;
    //             event.stopPropagation();

    //             $(vuChart.series).each(function (j, f) {
    //                 $(this.data).each(function (k, z) {
    //                     z.setState("");
    //                 });
    //             });
    //         });
    //     }
    // });

    // $("#" + healthLevelCharts.exportDashBoardVURef + vuId).data(healthLevelCharts.exportChartSvg, vuChart);
    // $("#" + healthLevelCharts.exportDashBoardVURef + vuId).data(healthLevelCharts.exportChartExportUrl, resultData.exportChartFullUrl);
    return chartOptions
}

const getPieSeriesName = function (
    vuChartData: { [s: string]: any },
    vuChartVariationType: any,
    seriesIndex: number
) {
    let seriesName = ''
    switch (vuChartVariationType) {
        case 'C_1M_1X_or_1Y':
        case 'C_1M_1X_and_1Y':
        default:
            seriesName = vuChartData.xAxis.category[seriesIndex]
            break
        case 'C_NM_1D':
        case 'C_2M_1X_or_1Y':
        case 'C_3M_1X_or_1Y':
            seriesName = vuChartData.dataSeries[seriesIndex].name

            break
    }
    return seriesName
}
